import { type EmploymentAnswers } from "@utils/jben/build_application";
import type { WhoamiProfile } from "@/queries/use_whoami";

export class EmploymentAutofiller {
  private answers: EmploymentAnswers;
  private setAnswers: (answers: EmploymentAnswers) => void;
  private config: string | undefined;

  constructor(
    answers: EmploymentAnswers,
    setAnswers: (answers: EmploymentAnswers) => void,
    config: string | undefined,
  ) {
    this.answers = answers;
    this.setAnswers = setAnswers;
    this.config = config;
  }

  fill(profile: WhoamiProfile): void {
    if (!this.shouldFill) return;

    const newAnswers = this.profileToAnswers(profile);
    if (newAnswers.length === 0) return;

    this.setAnswers(newAnswers);
  }

  private profileToAnswers(profile: WhoamiProfile): EmploymentAnswers {
    if (!profile.employments?.length) return [];

    return profile.employments.map((employment, index) => ({
      key: this.answers.length + index,
      companyName: employment.company ?? undefined,
      title: employment.title ?? undefined,
      startDateMonth: employment.startDate?.month,
      startDateYear: employment.startDate?.year,
      endDateMonth: employment.endDate?.month,
      endDateYear: employment.endDate?.year,
      currentRole: !employment.endDate,
    }));
  }

  private get shouldFill(): boolean {
    if (!this.hasEmploymentQuestions) return false;

    // If the user has manually provided ANY employment answer, do not autofill
    return !this.answers.some((answer) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { key: _key, ...attributes } = answer;
      return Object.keys(attributes).some((key) => !!attributes[key as keyof typeof attributes]);
    });
  }

  private get hasEmploymentQuestions(): boolean {
    return this.config === "optional" || this.config === "required";
  }
}
